import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Params} from "@angular/router";
import {LoginService} from "./login.service";

@Component({
    selector: 'app-email-verify',
    templateUrl: './emailverify.component.html',
})
export class EmailverifyComponent implements OnInit {
    showMsg:boolean = false;
    msg: string;
    msgType: string;
    constructor(
        private activatedRoute: ActivatedRoute,
        private loginService:LoginService,
    ){ }

    ngOnInit() {
        this.emailVerification();
    }

    emailVerification=function () {
        this.activatedRoute.params.subscribe((params: Params) => {
            let key = params['key']+"==";
            console.log("Key ======> ",key);
            this.showMsg = true;
            this.loginService.verifyMail(key).then(data => {
                console.log("Verification data ======> ",data["msg"]);
                this.msg = data['msg']
                if (data['status']  == 200) {
                    this.msgType = 'success'
                }else{
                    this.msgType = 'error'
                }
            }).catch(err => {
                console.log( 'err============>', err['msg'] );
                this.msg = err['msg']
                this.msgType = 'error'
            });
        });
    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/login/emailverify.component.ts